function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 管理范围组件
import manageRange from '@/components/form-common/select-manageRange';
import Commnt from '@/components/user/accessCommon.vue';
export default {
  name: 'FormBox',
  components: {
    manageRange: manageRange
  },
  props: {
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      pickerOptions: this.$pickerOptionsTimeEle,
      times: '',
      tableFrom: {
        id: '',
        time: '',
        scope_frame: '',
        category_id: ''
      },
      periodOptions: Commnt.periodOption,
      type: 0,
      statusOptions: Commnt.statusOptions,
      openStatus: false,
      activeDepartment: {},
      userList: [],
      checkList: [],
      title: '',
      showPerson: true,
      timeVal: [this.$moment().startOf('month').format('YYYY/MM/DD'), this.$moment().endOf('month').format('YYYY/MM/DD')]
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    lang: function lang() {
      this.setOptions();
    }
  },
  mounted: function mounted() {
    this.getTime();
    this.$emit('confirmData', this.tableFrom);
  },
  methods: {
    handleRange: function handleRange(e) {
      this.handleConfirm();
    },
    getTime: function getTime() {
      this.times = this.timeVal[0] + '-' + this.timeVal[1];
      this.tableFrom.time = this.times;
      return this.times;
    },
    getCategory: function getCategory() {
      return this.tableFrom.category_id;
    },
    setOptions: function setOptions() {},
    // 时间段选择
    selectChange: function selectChange() {
      this.timeVal = '';
    },
    // 重置
    reset: function reset() {
      this.timeVal = [this.$moment().startOf('month').format('YYYY/MM/DD'), this.$moment().endOf('month').format('YYYY/MM/DD')];
      this.times = this.timeVal[0] + '-' + this.timeVal[1];
      this.tableFrom.time = this.times;
      this.departmentList = [];
      this.tableFrom.frame = '';
      this.tableFrom.category_id = [];
      this.$refs.manageRange.reset();
      this.$emit('confirmData', this.tableFrom);
    },
    // 选择时间区域
    onchangeTime: function onchangeTime(e) {
      if (e == null) {
        this.tableFrom.time = '';
        this.tableFrom.times = '';
      } else {
        this.tableFrom.time = this.timeVal[0] + '-' + this.timeVal[1];
        this.tableFrom.times = this.timeVal[0] + '-' + this.timeVal[1];
        this.tableFrom.date = '';
      }
      this.handleConfirm();
    },
    // 确认
    handleConfirm: function handleConfirm() {
      this.confirmData();
    },
    confirmData: function confirmData() {
      this.$emit('confirmData', _objectSpread(_objectSpread({}, this.tableFrom), {}, {
        id: this.tableFrom.scope_frame
      }));
    },
    // 选择部门关闭
    departmentClose: function departmentClose() {
      this.openStatus = false;
    },
    // 选择成员完成回调
    changeMastart: function changeMastart(data) {
      this.tableFrom.scope_frame = data;
      this.handleConfirm();
    }
  }
};